import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import Nav from "@/components/Nav";
import IntroOverlay from "@/components/IntroOverlay";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Services from "@/components/Services";
import Manifesto from "@/components/Manifesto";
import Work from "@/components/Work";
import Reviews from "@/components/Reviews";
import ServiceArea from "@/components/ServiceArea";
import QuoteForm from "@/components/QuoteForm";
import Footer from "@/components/Footer";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="min-h-screen bg-white text-navy" data-testid="app-root">
      <Nav />
      <IntroOverlay />
      <main>
        <Hero />
        <Marquee />
        <Services />
        <Manifesto />
        <Work />
        <Reviews />
        <ServiceArea />
        <QuoteForm />
      </main>
      <Footer />
    </div>
  );
}

export default App;
